import type { FC } from 'react';
import React from 'react';
import useWindowSize from '@customHooks/useWindowSize';
import RecipesCarouselDesktop from './Desktop';
import RecipesCarouselMobile from './Mobile';
import './index.scss';

interface RecipesCarouselProps {
  recipes: any[];
  title?: string;
  isTitleLink?: boolean;
  smallHeading?: boolean;
  loop?: boolean;
}

const RecipesCarousel: FC<RecipesCarouselProps> = ({
  recipes,
  title = 'Популярные рецепты',
  isTitleLink,
  smallHeading,
  loop
}) => {
  const { isMobile } = useWindowSize();
  if (isMobile) {
    return (
      <RecipesCarouselMobile
        isTitleLink={isTitleLink}
        recipes={recipes}
        title={title}
      />
    );
  } else {
    return (
      <RecipesCarouselDesktop
        loop={loop}
        smallHeading={smallHeading}
        isTitleLink={isTitleLink}
        recipes={recipes}
        title={title}
      />
    );
  }
};

export default RecipesCarousel;
